import { render, staticRenderFns } from "./MermaidDiagram.vue?vue&type=template&id=39de4c1b&scoped=true"
import script from "./MermaidDiagram.vue?vue&type=script&lang=js"
export * from "./MermaidDiagram.vue?vue&type=script&lang=js"
import style0 from "./MermaidDiagram.vue?vue&type=style&index=0&id=39de4c1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39de4c1b",
  null
  
)

export default component.exports